import React from 'react';

// --- FUNCIÓN AUXILIAR: Para extraer mensaje de forma segura ---
const extractMessage = (message) => {
  if (typeof message === 'string') return message;
  if (message?.message && typeof message.message === 'string') return message.message;
  if (message?.summary && typeof message.summary === 'string') return message.summary;
  if (message?.summary && typeof message.summary === 'object') {
    return message.summary.message || JSON.stringify(message.summary);
  }
  if (typeof message === 'object') {
    return JSON.stringify(message);
  }
  return 'Mensaje no válido';
};

function FeedbackMessage({ feedback }) {
  if (!feedback || !feedback.message) {
    return null;
  }

  // Extraer el mensaje de forma segura
  const safeMessage = extractMessage(feedback.message);

  return (
    <div className={`feedback-message ${feedback.type}`}>
      {safeMessage}
    </div>
  );
}

export default FeedbackMessage;